import styled from 'styled-components';

export const CollectionTitle = styled.h3`
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 25px;
  color: ${({ theme }) => theme.colors.tertiary};
`;
